import { createReducer, Action, on } from '@ngrx/store';

import * as SoilTypeActions from './soil-type.actions';
import { SoilTypeState } from '../soil-type.model';

const reducer = createReducer<SoilTypeState>(
  {},
  on(SoilTypeActions.setSoilTypes, (state, { soilTypes }) => ({ ...state, soilTypes })),
);

export function soilTypeReducer(state: SoilTypeState | undefined, action: Action) {
  return reducer(state, action);
}
